<script>
import Site from './Site'
import GroupOrgPermission from './GroupOrgPermission'
import GroupUserPermission from './GroupUserPermission'

export default {
  name: 'configSitePermissionSiteGroup',
  extends: Site,
  components: {
    OrgPermission: GroupOrgPermission,
    UserPermission: GroupUserPermission
  },
  data () {
    return {
      headers: {
        title: '操作说明',
        content: '这里是站群权限分配'
      }
    }
  }
}
</script>
